/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { Base64 } from 'js-base64'
import Switch from 'react-switch'

import { CircularProgress } from '@material-ui/core'
import { FiCheck, FiClock } from 'react-icons/fi'

import usePersistedState from '../../hooks/usePersistedState'
import api from '../../services/api'

import ModalBox from '../../components/Modal'
import Button from '../../components/Button'
import Header from '../../components/Header'

import { Content, BtnVoltar, Confirmation } from './styles'
import {
  ConfigData,
  UserData,
  UserDetails,
  Participant,
  ErroProps,
} from '../../utils/interfaces'
import Container from '../../components/Container'

const Conclusion: React.FC = () => {
  const [userData] = usePersistedState<UserData>('userData', {} as UserData)

  const [configData] = usePersistedState<ConfigData>(
    'configData',
    {} as ConfigData,
  )
  const [userDetails] = usePersistedState<UserDetails>(
    'userDetails',
    {} as UserDetails,
  )
  const [participants] = usePersistedState<Participant[]>(
    'participantsGroup',
    [],
  )
  const [, setErroProps] = usePersistedState<ErroProps>(
    'erroProps',
    {} as ErroProps,
  )
  const [selectedReceive] = usePersistedState<'PD' | 'PS' | 'VF' | 'null'>(
    'receiveTypeSelected',
    'PD',
  )

  const [aguarde, setAguarde] = useState(false)
  const [timer, setTimer] = useState(0)
  const [reSend, setReSend] = useState(true)

  const [acceptTerms, setAcceptTerms] = useState(false)

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [warningText, setWarningText] = useState('')

  function handleCloseModal(): void {
    setIsModalOpen(false)
  }

  const history = useHistory()

  const handleConfirmaAdesao = useCallback(async () => {
    setAguarde(true)
    const parametros = Base64.encode(
      `{
        "token": "${configData.token}",
        "versao": "${configData.tipo}",
        "plano": "${configData.plano}",
        "nome": "${userData.name.toLowerCase()}",
        "cpf": "${userData.cpf.replaceAll('.', '').replace('-', '')}",
        "nascimento": "${userData.birthdate}",
        "admissao":"${userData.admission}",
        "email": "${userData.email}",
        "telefone": "55${userData.phone
          .replace('(', '')
          .replace(') ', '')
          .replace('-', '')}",
        "patrocinadora":"${userData.patrocinadora}",
        "nomeMae": "${userData.parental.toLowerCase()}",
        "salario": "${userDetails.salario}",
        "valor": "${userDetails.contribuicaoBasica
          .toString()
          .replace('.', ',')}",
        "pctCtbBasica": "${userDetails.pctContribuicaoBasica
          .toString()
          .replace('.', ',')}",
        "valorsuplementar": "${userDetails.contribuicaoSuplementar
          .toString()
          .replace('.', ',')}",
        "pctCtbSuplementar": "${userDetails.pctContribuicaoSuplementar
          .toString()
          .replace('.', ',')}",
        "idade_apos":"${userDetails.age}",
        "tempo_contribuicao": "${userDetails.years}",
        "politicamenteexposto": "${userDetails.ppe}",
        "usperson": "${userDetails.usperson}",
        "perfilInvest": "${userDetails.investor}",
        "forma_resgate": "${selectedReceive}",
        "beneficiarios": [${participants.map(
          participant => `
          {"nome": "${participant.data.name.toLowerCase()}",
          "nascimento": "${participant.data.birthdate}",
          "parentesco":"${participant.details.grauParentesco}",
          "tipo":"${participant.details.tipoBen}",
          "cpf": "${participant.data.cpf.replaceAll('.', '').replace('-', '')}",
          "mrcInvalidez":"${
            participant.details.mrcInvalidez === undefined
              ? ''
              : participant.details.mrcInvalidez
          }",
          "fator":"${
            participant.details.proporcao === undefined
              ? '0'
              : participant.details.proporcao.toString().replace('.', ',')
          }"}`,
        )}]
        }`,
    )

    const parametrosFinal = Base64.encode(parametros)

    // history.push('/end')

    await api
      .post(`wsAdesao.rule?sys=ADZ&Entrada=${parametrosFinal}`)
      .then(() => {
        localStorage.removeItem('@ASPPrev:configData')
        localStorage.removeItem('@ASPPrev:participantsGroup')
        localStorage.removeItem('@ASPPrev:PercentualValuePercent')
        localStorage.removeItem('@ASPPrev:receiveTypeSelected')
        localStorage.removeItem('@ASPPrev:TimeValueYears')
        localStorage.removeItem('@ASPPrev:totalBalance')
        localStorage.removeItem('@ASPPrev:userData')
        localStorage.removeItem('@ASPPrev:userDetails')
        localStorage.removeItem('@ASPPrev:erroProps')
        localStorage.removeItem('@ASPPrev:acceptTerms')
        localStorage.removeItem('@ASPPrev:RendaFixaValue')
        localStorage.removeItem('@ASPPrev:flagEdit')

        history.push('/end')
      })
      .catch(res => {
        if (res.message === 'Request failed with status code 401') {
          alert('Tempo de sessão expirado')
          history.push('/register')
        } else if (res.message === 'Request failed with status code 406') {
          setWarningText(
            'Adesão não autorizada. Verifique se você já possui cadastro no plano.',
          )
          setIsModalOpen(true)
          setReSend(false)
          setTimer(20)
          setAguarde(false)
        } else if (res.message === 'Network Error') {
          setErroProps({
            title: res.message,
            description: 'Falha na conexão como servidor',
          })
          history.push('/erro')
        } else if (res.message === 'Request failed with status code 500') {
          setErroProps({
            title: 'Erro interno no servidor',
            description: res.message,
          })
          history.push('/erro')
        } else if (res.message === 'Request failed with status code 408') {
          alert('Tempo de sessão expirado')
          history.push('/register')
        } else {
          setReSend(false)
          setTimer(20)
          setAguarde(false)
          setWarningText('Ops, algo deu errado. Tente novamente mais tarde.')
          setIsModalOpen(true)
        }
      })
  }, [
    configData,
    history,
    participants,
    selectedReceive,
    setErroProps,
    userData,
    userDetails,
  ])

  const toggleAcceptTerms = useCallback(() => {
    setAcceptTerms(!acceptTerms)
  }, [acceptTerms, setAcceptTerms])

  useEffect(() => {
    const countTimer = (): void => {
      if (timer > 1) {
        setTimer(timer - 1)
      } else if (timer === 1) {
        setTimer(timer - 1)
        setReSend(true)
      }
    }
    const interval = setInterval(countTimer, 1000)
    return () => clearInterval(interval)
  }, [timer])

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <Confirmation>
            <p>
              Eu, {userData.name}, inscrito no CPF <b>{userData.cpf}</b>,
              declaro que ao clicar em <b>Confirmar Adesão</b> estou confirmando
              minha adesão ao <b>Plano </b> e que as informações prestadas são
              verídicas.
            </p>

            <div>
              <small>
                Declaro que li e estou de acordo com o{' '}
                <a
                  href="https://aspprev.com.br/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  regulamento do plano
                </a>
              </small>
              <Switch
                onChange={toggleAcceptTerms}
                checked={acceptTerms}
                checkedIcon={false}
                uncheckedIcon={false}
                height={20}
                width={40}
                handleDiameter={16}
                offColor="#DEE3E1"
                offHandleColor="#fff"
                onHandleColor="#fff"
                onColor="#31D19E"
              />
            </div>
          </Confirmation>
        </Content>

        <Button
          type="button"
          color="blue"
          width="large"
          disabled={!acceptTerms || !reSend || aguarde}
          onClick={handleConfirmaAdesao}
        >
          {!aguarde ? (
            !reSend ? (
              <>
                <FiClock size={45} />
                <span>
                  Tente novamente em {timer < 10 ? `0${timer}` : timer} segundos
                </span>
              </>
            ) : (
              <>
                <FiCheck size={45} />
                <span>Confirmar adesão</span>
              </>
            )
          ) : (
            <>
              <CircularProgress color="inherit" />
              <span>Aguarde</span>
            </>
          )}
        </Button>
        <BtnVoltar type="button" onClick={() => history.push('/resume')}>
          &lt; Anterior
        </BtnVoltar>

        <ModalBox isOpen={isModalOpen} onRequestClose={handleCloseModal}>
          <p>{warningText}</p>
        </ModalBox>
      </Container>
    </>
  )
}

export default Conclusion
